<template>
    <div>
        <Header title="客户来源">
            <template v-slot:content>
                <div style="display: flex">
                    <div style="flex:1">
                    </div>
                    <div>
                        <Button type="primary" @click="add">新增</Button>
                    </div>
                </div>
            </template>
        </Header>
        <div class="my-white-mod">
            <PageTable  :loading="table.loading"  :columns="table.columns"  :size="table.limit"  :data="table.data" :current="table.current" :total="table.total" @switchPage="changepage" >
            </PageTable>
        </div>


        <Modal
                v-model="show_success"
                :title="title"
                width="400"
                @on-ok="update"
        >
            <div class="modal-title">来源名称</div>
            <Input  placeholder="请填写来源名称"  v-model="submit_form.name" />
        </Modal>
        <Modal
                v-model="show_del"
                title="删除"
                width="400"
                @on-ok="delete_needs"
        >
            <div class="my-modal-del">
                <Icon type="ios-alert" />
                是否删除该来源名称
            </div>
        </Modal>
    </div>

</template>
<script>
    import {source_del, source_manager, customer_source_list} from "@/api/system";
    import {Header, PageTable} from "@/components/mainLayout"
    export default {
        components:{
            Header,
            PageTable
        },
        data(){
            return{
                title:"新增",
                show_success:false,
                show_del:false,
                delete_id:0,
                submit_form:{
                    name:"",
                },
                table:{
                    current:1,
                    total:0,
                    limit:30,
                    loading:false,
                    columns: [
                        {
                            align:'center',
                            type: 'index'
                        },
                        {
                            title: '来源名称',
                            align:'center',
                            key: 'name'
                        },
                        {
                            title: '添加时间',
                            align:'center',
                            key: 'ctime'
                        },
                        {
                            title: '操作',
                            align:'center',
                            key: 'id',
                            render: (h, params) => {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#3F8CFF'},
                                        on: {
                                            click: () => {
                                                this.edit(params)
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#ff0000'},
                                        on: {
                                            click: () => {
                                                this.del(params);
                                            }
                                        }
                                    }, '删除')
                                ]);

                            }

                        }
                    ],
                    data: []
                }

            }
        },
        mounted(){
            this.list()
        },
        methods:{
            list(){
                this.table.loading = true;
                customer_source_list({limit:this.table.limit, page:this.table.current}).then(res=>{
                    this.table.loading = false;
                    if (res.code == 200) {
                        this.table.data = res.data
                        this.table.total = res.total
                    } else {
                        this.table.data = []
                        this.table.total = 0
                    }
                })
            },
            update(){
                if (this.submit_form.name == "" ){
                    this.$Message.error("系统名称不能为空");return;
                }
                source_manager(this.submit_form).then(res=>{
                    if (res.code == 200) {
                        this.list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            delete_needs(){
                source_del({id:this.delete_id}).then(res=>{
                    if (res.code == 200) {
                        this.list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            add(){
                this.title = "新增";
                this.show_success = true;
                this.submit_form = {
                    name : "",
                    sort:999
                };
            },
            edit(e){
                this.submit_form = e.row;
                this.title = "编辑";
                this.show_success = true;
            },
            del(e){
                this.show_del = true;
                this.delete_id = e.row.id;
            },
            changepage(index){
                this.table.current = index;
                this.list();
            }
        }
    }
</script>
